import { createAction, props } from '@ngrx/store';
import { IDisclosureData, IDisclosureModel } from '@partners/api';

export class DisclosureActions {
  static reset = createAction('[Disclosure] Reset State');
  static updateModel = createAction('[Disclosure] Update Model', props<{ model: IDisclosureModel }>());

  static load = createAction('[Disclosure] Load');
  static loadSuccess = createAction(
    '[Disclosure] Load Success',
    props<{ model: IDisclosureModel; data: IDisclosureData }>()
  );
  static loadFailure = createAction('[Disclosure] Load Failure', props<{ error: any }>());
  static submit = createAction('[Disclosure] Submit');
  static submitSuccess = createAction(
    '[Disclosure] Submit Success',
    props<{ model: IDisclosureModel; data: IDisclosureData }>()
  );
  static submitFailure = createAction('[Disclosure] Submit Failure', props<{ error: any }>());
}
